import { useEffect, useState } from 'react';
import { api, type AppView } from '../api/client';
import { AccessBadge } from '../components/AccessBadge';
import { ErrorBanner } from '../components/ErrorBanner';
import { navigate } from '../router';

export function AppsList({ adminClientId }: { adminClientId: string }) {
  const [apps, setApps] = useState<AppView[] | undefined>();
  const [error, setError] = useState<unknown>();

  useEffect(() => {
    api.list().then(setApps).catch(setError);
  }, []);

  if (error) return <ErrorBanner error={error} />;
  if (!apps) return <p className="muted">Loading…</p>;

  return (
    <>
      <div className="pagehead">
        <h1>Registered apps</h1>
        <button type="button" className="primary" onClick={() => navigate('/apps/new')}>
          Register an app
        </button>
      </div>

      {apps.length === 0 ? (
        <p className="muted">No apps are registered yet.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>App</th>
              {/* Headed ACCESS, never "Groups": see AccessBadge for why an empty cell here would be
                  actively misleading. */}
              <th>Access</th>
              <th>Status</th>
              <th>Updated</th>
            </tr>
          </thead>
          <tbody>
            {apps.map((app) => (
              <tr key={app.client_id}>
                <td>
                  <a
                    href={`/apps/${encodeURIComponent(app.app_name)}`}
                    onClick={(e) => {
                      e.preventDefault();
                      navigate(`/apps/${encodeURIComponent(app.app_name)}`);
                    }}
                  >
                    {app.app_name}
                  </a>
                  {app.client_id === adminClientId && <span className="tag">this console</span>}
                </td>
                <td>
                  <AccessBadge groupIds={app.required_group_ids} />
                </td>
                <td>
                  {app.enabled ? (
                    <span className="badge badge-ok">Enabled</span>
                  ) : (
                    <span className="badge badge-off">Disabled</span>
                  )}
                </td>
                <td className="muted small">
                  {app.updated_at.slice(0, 10)}
                  {app.updated_by ? ` · ${app.updated_by}` : ''}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
